import { render, staticRenderFns } from "./GoodsForm1.vue?vue&type=template&id=3a132c10&scoped=true&"
import script from "./GoodsForm1.vue?vue&type=script&lang=js&"
export * from "./GoodsForm1.vue?vue&type=script&lang=js&"
import style0 from "./GoodsForm1.vue?vue&type=style&index=0&id=3a132c10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a132c10",
  null
  
)

export default component.exports